<template>
  <section class="hebergementSection">
    <div class="giteContainer filNav">
      <router-link to="/">Bienvenue</router-link>
      <span>></span>
      <router-link to="/nos-hebergements" title="Nos différents Hébergements">Hébergements</router-link>
      <span>></span>
      <a>{{ listHeb[categorie].title }}</a>
    </div>

    <section class="giteContainer presentation">
      <div class="somePadd">
        <h2>{{ listHeb[categorie].title }}</h2>
        <p class="biggerText" v-html="listHeb[categorie].description"></p>

        <p class="italic" v-html="listHeb[categorie].subDesc"></p>

        <div class="resaBtnBox">
          <!-- <a @click="$parent.showReservation = !$parent.showReservation">RÉSERVER</a> -->
          <a @click="$parent.showReservation = !$parent.showReservation">DISPONIBILITÉ</a>
        </div>
      </div>
      <div class="imgViewer">
        <Slideshow
          sliderheight="500px"
          rightnav_class="fas fa-angle-right fa-3x"
          leftnav_class="fas fa-angle-left fa-3x"
        >
          <div v-for="(img) in listHeb[categorie].imgs" :key="img">
            <img :src="getImg(img)" alt="Gite en lebé" />
          </div>
        </Slideshow>

        <p class="situationText">
          Situation : à 6km de la gare de Gimont, à 50km de Toulouse et de l'aéroport de Blagnac.
          <router-link to="/contact" title=" plan page contact">Plan d'accès cliquez ici</router-link>
        </p>
      </div>
    </section>

    <section class="giteContainer">
      <br />
      <p class="biggerText">
        Soyez rassurés, nous attachons une importance toute particulière à votre confort, mais surtout à votre santé. Nous privilégions l’hygiène et la propreté pour
        l’ensemble de nos structures. Egalement, de par notre métier en agriculture biologique, le respect de l’environnement fait partie de nos priorités.
      </p>
      <p class="biggerText">
        Durant cette période très particulière et afin de toujours vous satisfaire, nous nous adapterons à vos demandes en terme de durée de séjour.
        Nous pratiquons déjà un planning « à la carte », même en période estivale, sans aucune obligation de location du samedi au samedi.
        Vous êtes libres de fixer vos dates, en respectant bien entendu la disponibilité des hébergements.
      </p>
      <br />
    </section>

    <section class="giteContainer tarifsSection">
      <h2 class="titlePage">
        <strong>_</strong>
        Tarifs
        <strong>_</strong>
      </h2>
      <br />
      <div class="scrollX">
        <table>
          <tr>
            <th></th>
            <th>Gîte 17 personnes</th>
            <th>Gîte 10 personnes</th>
            <th>Gîte 2 personnes</th>
            <th>Les 2 gîtes</th>
          </tr>
          <tr>
            <td>Week-end (1 ou 2 nuits )</td>
            <td>800 €</td>
            <td></td>
            <td>140 €</td>
            <td></td>
          </tr>

          <tr>
            <td>3 nuits</td>
            <td>900 €</td>
            <td></td>
            <td>160 €</td>
            <td></td>
          </tr>

          <tr>
            <td>4 nuits</td>
            <td>1000 €</td>
            <td></td>
            <td>180 €</td>
            <td></td>
          </tr>

          <tr>
            <td>Nuits supplémentaire</td>
            <td>250 €</td>
            <td></td>
            <td>45 €</td>
            <td></td>
          </tr>

          <tr>
            <td>Semaine en basse saison</td>
            <td>1300 €</td>
            <td>460 €</td>
            <td>280 €</td>
            <td></td>
          </tr>

          <tr>
            <td>Semaine en moyenne saison</td>
            <td>1300 €</td>
            <td>580 €</td>
            <td>280 €</td>
            <td></td>
          </tr>

          <tr>
            <td>Semaine en avant saison (du 30/06 au 13/07)</td>
            <td>1900 €</td>
            <td>700 €</td>
            <td>350 €</td>
            <td>2100 €</td>
          </tr>

          <tr>
            <td>Semaine en haute saison (du 14/07 au 31/08)</td>
            <td>2400 €</td>
            <td>800 €</td>
            <td>450 €</td>
            <td>2600 €</td>
          </tr>
        </table>
      </div>
    </section>
    <GreenBarContact></GreenBarContact>
  </section>
</template>

<script>
import Slideshow from "@/components/Slideshow.vue";
import GreenBarContact from "@/components/GreenBarContact.vue";

export default {
  name: "HebergementItem",

  computed: {
    mainImage: {
      get: function () {
        return require("@/assets/images/" +
          this.listHeb[this.categorie].imgs[this.imgToCatch]);
      },
    },
  },
  components: {
    Slideshow,
    GreenBarContact,
  },

  data: function () {
    return {
      imgToCatch: 1,
      categorie: "",
      listHeb: [
        {
          title: "Le gîte",
          description: `Un repas de famille, un anniversaire, une cousinade, un mariage ou autre, toutes les occasions sont bonnes pour se retrouver,
           le gite de groupe peut convenir pour 10 ou 17 personnes, en fonction de votre groupe.
            `,
          subDesc: `Labellisé Gîtes de France (3 Epis) et Tourisme & Handicap. <br/>
              Vous profiterez du charme de la campagne, de son silence.<br/>
              Joli parc arboré avec terrain de pétanque et mobilier de jardin.<br/>
              Agréable parking privatif.<br/>
              Grand espace de vie avec cheminée. Cuisine parfaitement équipée et fonctionnelle.<br/>
              3 grandes chambres en rez-de-chaussée, avec sanitaires privatifs, climatisées et équipées de TV.<br/>
              A l’étage, une chambre et un grand dortoir climatisés, avec sanitaires.<br/>
              Les animaux sont accueillis, toujours sous la responsabilité de leur maître et avec obligation de respecter les lieux.<br/>
              `,
          imgs: [
            "grandgite/Cuisine.jpg",
            "grandgite/dortoirA.jpg",
            "grandgite/P1070847.jpg",
            "grandgite/P1070860.jpg",
            "grandgite/P1070885.jpg",
            "grandgite/P1070887.jpg",
            "grandgite/P1070893.jpg",
            "grandgite/terrainpetanque.jpg",
          ],
        },
        {
          title: "Les chambres d'hôtes",
          description: `Et si vous préférez la formule Chambres d’Hôtes, 3 belles pièces de caractère, très confortables ont été aménagées en rez-de-chaussée. 
              Elles sont climatisées et équipées d’une tv.
             L’une d’entre elles est labellisées « Tourisme et Handicap ». Nous serons ravis de vous préparer un petit déjeuner « fait maison », élaboré avec des produits locaux et de saison. `,
          subDesc: `Les 3 chambres sont situées au rez-de-chaussée de la bâtisse. Une d’entre elles est accessible aux personnes à mobilité réduite.<br/>
              Climatisation, TV, accès wifi<br/>
              Literie confortable<br/>
              Les petits-déjeuners ont la réputation d’être copieux et gourmands. « Fait maison » garanti !<br/>
              `,
          imgs: [
            "Chambredhote/03.jpg",
            "Chambredhote/06.jpg",
            "Chambredhote/07.jpg",
          ],
        },
        {
          title: "Le studio",
          description: `
           Pour un séjour plus tranquille, le temps d’un week-end ou plus, le petit gîte pour 2 personnes vous offre tout le confort et le calme dont vous rêvez.
           Charmant petit gîte pour une ou 2 personnes.<br/>
          Confortable et climatisé.<br/>
          Idéal pour découvrir notre territoire en toute indépendance<br/>
           Vous êtes tout à fait autonomes et vivez à votre rythme.
           `,
          subDesc: `Cet hébergement de caractère, avec ses murs en pierre, correspond parfaitement à ceux qui souhaitent profiter des activités et des découvertes en toute liberté. <br/>
            Vous serez complètement autonomes et indépendants. <br/>
            Pièce de vie avec cuisine équipée, accès wifi, TV, climatisation. <br/>
            Chambres indépendante avec salle d’eau. WC
            `,
          imgs: [
            "Studio/Studio A.jpg",
            "Studio/Studio.jpg",
            "Studio/Studio B.jpg",
            "Studio/Studio C.jpg",
            "Studio/Studio D.jpg",
          ],
        },
      ],
    };
  },
  created() {
    switch (this.$route.params.type) {
      case "le-gite":
        this.categorie = 0;
        break;
      case "chambres-d-hotes":
        this.categorie = 1;
        break;
      case "studio":
        this.categorie = 2;
        break;
      default:
        this.categorie = 0;
        break;
    }
  },

  methods: {
    getImg(img) {
      return require("@/assets/images/" + img);
    },
  },
};
</script>

<style>
.filNav span {
  margin: 0 4px;
}

.presentation {
  display: flex;
}

.presentation > * {
  width: 50%;
}

.presentation .somePadd {
  padding-top: 5%;
}

.presentation div:first-child p {
  max-width: 70%;
}

.italic {
  font-style: italic;
}

.presentation h2 {
  font-size: 3rem;
  margin: 0;
  font-weight: 100;
  font-variation-settings: "wght" 1000;
  color: var(--dark-color);
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
}

.biggerText {
  font-size: 1.3rem;
  font-weight: 100;
}

.resaBtnBox {
  display: flex;
  justify-content: space-evenly;
  max-width: 70%;
  margin-top: 2rem;
}

.resaBtnBox a {
  color: var(--dark-color);
  padding: 1rem 2.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 0 0px 2px var(--dark-color);
  font-weight: bold;
}

.resaBtnBox a:hover {
  background-color: var(--dark-color);
  color: white;
  transition: all 0.3s ease;
}
.bigsmallsImgBoxEl {
  height: 400px;
  margin-bottom: 1rem;
  overflow: hidden;
}
.theBigImg {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: all 0.5s ease;
}

.navSlide .imageContainer > * {
  padding: 0 8px;
}
.navSlide .slideBtn {
  background: white;
  border-radius: 40%;
  padding: 4px 8px;
}
.navSlide .btnLeft {
  left: 0;
}
.navSlide .btnRight {
  right: 0;
}
.scrollXImg {
  overflow-x: auto;
  position: relative;
}

.arrowNav:first-child {
  right: unset;
  left: 0;
}
.smallsImgBox {
  display: inline-flex;
  justify-content: space-between;
  width: fit-content;
}

.smallsImgBox > * {
  width: 29%;
  height: 160px;
  object-fit: cover;
  margin-right: 1%;
  cursor: pointer;
}

.situationText {
  font-size: 1.1rem;
}

.situationText a {
  text-decoration: underline;
  text-decoration-color: dimgray;
}
.imgFade-enter-active,
.imgFade-leave-active {
  transition: opacity 0.5s;
}
.imgFade-leave-to {
  display: none;
}
.imgFade-enter {
  opacity: 0.8;
}

.tarifsSection {
}
.imgViewer .imageContainer > * > * {
  object-fit: contain;
}
.imgViewer .slideBtn {
  height: 50px;
  width: 50px;
  background: white;
  border-radius: 50%;
  border: 2px var(--dark-color) solid;
  color: var(--dark-color);
}
.imgViewer .btnLeft {
  left: -25px;
}
.imgViewer .btnRight {
  right: -25px;
}
.imgViewer .slideBtn:hover {
  background: var(--dark-color);
  color: white;
  transition: 0.3s ease;
}
table {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  margin-bottom: 2rem;
}
tr:nth-child(even) {
  background: #fff;
}
th,
tr:nth-child(odd) {
  background: rgb(228, 236, 218);
}
th,
td {
  padding: 1rem 0;
}
.notcurrImg {
  opacity: 0.7;
  transition: all 0.3s ease;
}
@media all and (max-width: 1400px) {
  .giteContainer {
    margin: 0 5%;
  }
  .presentation div:first-child p {
    max-width: 90%;
  }
}

@media all and (max-width: 1100px) {
  .presentation {
    flex-direction: column;
  }
  .presentation > * {
    width: 100%;
  }
  .presentation .somePadd {
    padding-bottom: 5%;
    padding-top: 0;
  }
  .resaBtnBox {
    max-width: 100%;
  }
  .somePadd h2 {
    margin-bottom: 0;
  }
  .biggerText {
    margin-top: 0;
  }
}
@media all and (max-width: 1000px) {
  .filNav {
    display: none;
  }
}

@media all and (max-width: 768px) {
  .giteContainer {
    margin: 0 8px;
  }

  .tarifsSection {
    overflow-x: scroll;
  }
  table {
    min-width: 700px;
  }

  .arrowNav {
    display: none;
  }
  .smallsImgBox {
    flex-wrap: wrap;
  }
  .smallsImgBox > * {
    width: 32%;
    height: 70px;
    margin-bottom: 4px;
  }
}

@media all and (max-width: 400px) {
  .resaBtnBox {
    flex-direction: column;
  }
  .resaBtnBox a {
    margin: 8px 0;
    text-align: center;
  }
}
</style>